import isEmpty from 'lodash/isEmpty';

export default ({ loanIdentifierCalledAs }) => (!isEmpty(loanIdentifierCalledAs) && (loanIdentifierCalledAs.toLowerCase() !== 'account number')
    ? loanIdentifierCalledAs
    : null);
